module.exports = __webpack_public_path__ + "img/title.fdbc72da.png";